const UTILS = {
  async Geolocate(address) {
    var geocoder = new google.maps.Geocoder();
    if (!address) return;
  
    let results = await geocoder.geocode({ address: address });
  
    return results;  
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },
  async PromisesSequential(PromiseArr) {
    let res = [];
    for (let i = 0; i < PromiseArr.length; i++) {
      res.push(await PromiseArr[i]);
    }
    return res;  
  }
};

function MapsLoaded() {}

document.addEventListener('alpine:init', (e) => {
  Alpine.data('Dealers', () => ({
    $section: null,
    stores: [],
    filteredStores: [],
    qs_stores: [],
    countries: [],
    selected: {
      country: '',
      searchQuery: ''
    },
    map: null,
    SELECTORS: {
      dealer_map: '#dealers-map',
      stores_json: '[data-stores-json]'
    },
    init() {
      let am = this;
      document.addEventListener('init-Dealers', (e) => {
        if (am.$section) return;

        am.$section = e.target;
        am.LoadStores();
        am.LoadGoogleMap();
      });

      am.$watch('selected.country', am.FilterStores.bind(am));
      am.$watch('selected.searchQuery', am.FilterStores.bind(am));
    },

    LoadStores() {
      let am = this;
      UTILS.ConvertStringToJS(am.$section.querySelector(am.SELECTORS.stores_json).innerHTML);

      let ranked_stores = [...stores.filter(store => !isNaN(store.order))];
      let non_ranked_stores = [...stores.filter(store => isNaN(store.order))].sort((a,b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
      // console.log(ranked_stores, non_ranked_stores);

      // sort alphabetically
      stores = [...ranked_stores, ...non_ranked_stores];
      am.stores = am.filteredStores = stores;

      // countries
      let countries = [];
      stores.forEach((store) => {
        if (countries.indexOf(store.map_country) == -1) {
          countries.push(store.map_country);
        }
      });
      am.countries = countries;

      let qs_stores = new quickScore.QuickScore(am.stores, ["title", "map_address"], {
        minimumScore: 0.7
      });
      am.qs_stores = qs_stores;
      // console.log(qs_stores);
    },

    LoadGoogleMap() {
      let am = this;
      let api_key = am.$section.dataset.api_key;
      let script = document.createElement('script');
      script.onload = function () {
        am.InitMap();
      };
      script.src = `https://maps.googleapis.com/maps/api/js?key=${ api_key }&callback=MapsLoaded`;
      document.head.appendChild(script);
    },

    InitMap() {
      let am = this;
      (async() => {
        let store = await UTILS.Geolocate(am.stores[0].map_address);
        store = store.results[0];
      
        let store_lat_lng = {
          lat: store.geometry.location.lat(), 
          lng: store.geometry.location.lng()
        };
      
        // Create the map.
        const map = new google.maps.Map(document.querySelector(am.SELECTORS.dealer_map), {
          zoom: 3.15,
          center: store_lat_lng,
        });
        am.map = map;

        am.AddMarkers();
      })();
    },

    AddMarkers() {
      let am = this;
      (async() => {
        let px_addresses = am.stores.map(async(store) => {
          return await UTILS.Geolocate(store.map_address);
        });

        let addresses = await UTILS.PromisesSequential(px_addresses);
        addresses = addresses.map(item => item.results[0]);
        
        addresses.forEach((address, index) => {
          let store = am.stores[index];

          const store_lat_lng = {
            lat: address.geometry.location.lat(), 
            lng: address.geometry.location.lng()
          }
      
          let marker = new google.maps.Marker({
            position: store_lat_lng,
            map: am.map,
            title: store.title
          });

          // capture into store
          store.geometry = address.geometry;
          store.marker = marker;
          // console.log(store);

          // info modal
          let infowindow = new google.maps.InfoWindow({
            content: `
              <h3 class="dealer-title">${ store.title }</h3>
              <div class="dealer-address">${ store.map_address }</div>
              <div class="dealer-brief-content">${ store.content }</div>
            `,
            ariaLabel: store.title,
          });
          store.infowindow = infowindow;
      
          marker.setMap(am.map);
          // console.log(marker);
      
          marker.addListener('click', (e) => {
            // console.log(e);
            am.ZoomToStore(e, store);
          });    
        });
      })();
    },

    ZoomToStore(e, store) {
      let am = this;
      // console.log(e, store);
      am.map.setZoom(15);
      am.map.panTo(store.marker.position);

      store.infowindow.open({
        anchor: store.marker,
        map: am.map,
      });
    },

    FilterStores() {
      let am = this;

      let searchQuery = am.selected.searchQuery;
      let search_stores = [];
      if (searchQuery !== '') {
        search_stores = am.qs_stores.search(searchQuery).map(item => item.item);
      }

      am.filteredStores = am.stores.filter((store) => {
        let flag = true;
        let search_match = search_stores.find(item => item.title == store.title);
        if (searchQuery !== '') {
          flag = search_match ? true : false;
        }

        let country_match = (am.selected.country != '') ? store.map_country == am.selected.country : true;
        flag = flag && country_match;

        // console.log(store, flag)
        store.marker.setVisible(flag);

        return flag;
      });
    }
  }));
});